export enum LOYALTY_BENEFITS_NAMES {
  customPromo = 'customPromo',
  customTournaments = 'customTournaments',
  dailyPayouts = 'dailyPayouts',
  featureAccess = 'featureAccess',
  giftBaskets = 'giftBaskets',
  marketing = 'marketing',
  paidTrips = 'paidTrips',
  personalizedGifts = 'personalizedGifts',
  promoCodes = 'promoCodes',
  sponsoredPayments = 'sponsoredPayments',
  techGifts = 'techGifts',
  vip = 'vip',
}
